import React from 'react';
import Avatar from './Avatar';
import './ChatHead.css';

interface ChatHeadProps {
  onClick: () => void;
  hasUnreadMessages?: boolean;
  isOnline?: boolean;
  className?: string;
}

const ChatHead: React.FC<ChatHeadProps> = ({
  onClick,
  hasUnreadMessages = false,
  isOnline = true,
  className = ''
}) => {
  return (
    <div 
      className={`chat-head ${className}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      aria-label="Open chat"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <Avatar
        src="/avatar_half.png"
        alt="Chat Assistant"
        fallbackText="AI"
        size="large"
        className="avatar--assistant"
        isOnline={isOnline}
      />
      
      {/* Unread message indicator */}
      {hasUnreadMessages && (
        <div 
          className="chat-head__unread-indicator"
          aria-label="You have unread messages"
        />
      )}
      
      {/* Pulsing wave animation for attention */}
      <div className="chat-head__pulse" aria-hidden="true" />
      <div className="chat-head__wave-ring chat-head__wave-ring--1" aria-hidden="true" />
      <div className="chat-head__wave-ring chat-head__wave-ring--2" aria-hidden="true" />
      <div className="chat-head__wave-ring chat-head__wave-ring--3" aria-hidden="true" />
    </div>
  );
};

export default ChatHead;